import React from 'react';
import ButtonApi from '../../../../components/ButtonApi';
import NftPreview from '../../../../components/nft/NftPreview';
import { useMint } from './MintNftProvider';

const StepMintPreview = () => {
  const [{ username, mint }] = useMint();
  return (
    <>
      <h2>LET "{username}" BE GLORIOUS</h2>
      <p>Here's your initial Identity Relic from the syndicate. Remember rituals? Complete them in the journey ahead, and see the Relic evolve and change it's shape for you.</p>
      <NftPreview
        className='final_nft_preview'
        src={'https://resolve.timesnap.xyz/ipfs/bafkreibzeugrszwi5fzgkplaqvy7i7gtqgzwmblnlv2tpal6dz5n7n43pu'}
      />
      <ButtonApi onClick={mint}>Claim Now</ButtonApi>
    </>
  );
};

export default StepMintPreview;
